/* eslint-disable react/jsx-no-undef */
import * as React from "react";
import {
    IGenericUserProps,
    genericMapStateToProps,
} from "../../../DataClasses/GenericUser";
import {
    Theme,
    WithStyles,
    createStyles,
    withStyles,
} from "@material-ui/core/styles";
import idssStyle from "../../../Configuration/SharedStyling";
import { connect } from "react-redux";
import { Button, Fade, Grid, IconButton, Paper, TextField, Tooltip } from "@material-ui/core";
import Select from "react-select";
import LoadingDataTable from "../../Shared/LoadingDataTable";
import MUIDataTable, { MUIDataTableColumn, MUIDataTableOptions } from "mui-datatables";
import { SeedTime } from "../../../Configuration/Setting";
import { firstValueFrom } from "rxjs";
import AdministrationService from "../../Services/AdministrationService";
import { Redirect } from "react-router-dom";
import { AjaxError } from "rxjs/ajax";
import GetAppIcon from '@material-ui/icons/GetApp';

const CustomToolbar = ({ canDownloadAll, onDownloadAll }: { canDownloadAll: boolean; onDownloadAll: () => void }) => (
    <Button
      style={{ display: canDownloadAll ? "inline-flex" : "none" }}
      variant="contained"
      color="primary"
      onClick={onDownloadAll}
    >
      Download All
    </Button>
  );


const styles = (theme: Theme) => createStyles({
    ...idssStyle(theme),
    paperStyle: {
        flexGrow: 0,
        padding: theme.spacing(2, 2),
        width: "62%"
    }
});
interface IHistoricalFilesStateStore {
    isLoading: boolean;
    selectedMys: any;
    inputSubIds: string;
    tableData: any[];
    showTable: boolean;
    redirect: boolean
}

type Props = WithStyles<typeof styles>;

class HistoricalFilesView extends React.Component<
    IGenericUserProps & Props,
    IHistoricalFilesStateStore
> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            selectedMys: "",
            inputSubIds: "",
            tableData: [],
            showTable: false,
            redirect: false
        }
    }

    
    public render() {
        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }
        const { classes } = this.props;
        const yearOptions = this.getYearOptions();
        const ftOptions: MUIDataTableOptions = {
            filter: true,
            filterType: "dropdown",
            responsive: "standard",
            selectableRows: "none",
            download: false,
            print: false,
            viewColumns: false,
            rowsPerPage: 10,
            rowsPerPageOptions: [10, 20, 50],
            customToolbar: () => <CustomToolbar canDownloadAll={this.canDownloadAll()} onDownloadAll={() => this.downloadAll()} />,
        };
        return (
            <div>
                <Paper className={classes.paperStyle}>
                    <Grid item={true} xs={12}>
                      <table><tbody><tr>
                        <td style={{ width: "200px" }} >Select Measurement Year(s): </td>
                        <td style={{ width: "280px" }}>
                            <Select
                                options={yearOptions}
                                placeholder="Select MeasurementYear(s)"
                                isMulti={true}
                                matchProp="label"
                                simpleValue={true}
                                value={this.state.selectedMys}
                                closeOnSelect={false}
                                searchable={true}
                                onChange={this.selectedMyChange.bind(this)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </td>
                        <td style={{ width: "20px" }} ></td>
                        <td style={{ width: "70px" }} >SubID(s): </td>
                            <td style={{ width: "350px" }}>
                                <TextField placeholder="Comma separated SubIds (e.g: 1234,9876)" value={this.state.inputSubIds} variant="outlined" style={{ width: "330px" }} onChange={(e) => this.handleInputSubIdsChange(e)} multiline
                                    maxRows={3} />
                        </td>
                            <td>
                                <Button onClick={() => this.getFileList()} disabled={!this.isInputValid() || this.state.isLoading}>Get Files</Button>
                        </td>
                        </tr></tbody></table>
                    </Grid>
                    <br/>
                    {this.state.showTable && <Grid item={true} xs={11}>
                        {this.state.isLoading ? (
                            <LoadingDataTable titleText={"*"} />
                        ) : (
                            <Fade in={true} {...{ timeout: SeedTime }}>
                                <MUIDataTable
                                    title={""}
                                    data={this.state.tableData}
                                    columns={this.getTableColumns()}
                                    options={ftOptions}
                                />
                            </Fade>

                        )}
                    </Grid>}
               </Paper>
            </div>
        );
    }

    private renderCustomDownloadButton ( value: number, tableMeta: any) {
        let tipTxt = "Download File";
        if (value <= 0) {
            return (
                <div>
                    File not found
                </div>
            );
        } else {
            return (
                <div>
                    <Tooltip title={tipTxt} aria-label={tipTxt}>
                        <IconButton onClick={() => this.downloadFile(value, tableMeta.rowData)}>
                            <GetAppIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        }
    };
    private getTableColumns() {
        return [
            {
                name: "measurementYear",
                label: "MeasurementYear",
            },
            {
                name: "submissionId",
                label: "SubmissionId",
            },
            {
                name: "fileType",
                label: "FileType",
            },
            {
                name: "fileTypeId",
                label: "Download",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta) => this.renderCustomDownloadButton(value, tableMeta),
                    download: false
                }
            },
        ] as MUIDataTableColumn[];
    }

    private canDownloadAll = () => {
        if(this.state.tableData.length == 0) return false;

        return this.state.tableData.some(x => x.fileTypeId > 0);
    }

    private downloadAll = async(): Promise<void> => {   
        try {
            const response = await firstValueFrom(
                AdministrationService.GetHistoricalFilesZip(this.props.user, this.state.tableData)
            );
    
            const blob = new Blob([response.response as ArrayBuffer], { type: 'application/zip' });
    
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.download = 'historicalFiles.zip';

            document.body.appendChild(link);

            link.click();
    
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading ZIP file:", error);
        }
          
    }

    private downloadFile = async (fileTypeId: number, rowData: any): Promise<void> => {
        let fileUrl = await this.getDownloadUrl(rowData[0], rowData[1], fileTypeId);
        window.location.href = fileUrl;
    }
    private getDownloadUrl = async (measurementYear: number, submissionId: number, fileTypeId: number) : Promise<string> => {
        let retval = await firstValueFrom(AdministrationService.GetHistoricalFileDownloadUrl$(this.props.user, measurementYear, submissionId, fileTypeId));
        return retval;
    }
    private async getFileList() {
        this.setState({ isLoading: true, showTable: true });
        let mys = this.state.selectedMys.map(my => my.value).join(",");
        let retval: any[] = await firstValueFrom(AdministrationService.AdminGetHistoricalFileList$(this.props.user, mys, this.state.inputSubIds));
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        }
        else {
            this.setState({
                tableData: retval
            });
        }
        this.setState({ isLoading: false });
    }
    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }
    private setRedirectState() {
        this.setState({ redirect: true });
    }

    private getYearOptions() {
        let maxMy = new Date().getFullYear() - 1;
        if (new Date().getMonth() < 7) {
            maxMy = maxMy - 1;
        }
        let retval = [];
        for (let my = maxMy; my >= 2020; my--) {
            retval.push({ value: my, label: my.toString() });
        }
        return retval;
    }
    private handleInputSubIdsChange(e) {
        this.setState({ inputSubIds: e.target.value });
    }
    selectedMyChange(mys: any) {
        this.setState({ selectedMys: mys});    
    }
    isInputValid(): boolean {
        const isCommaSeparatedInts = (input: string): boolean => {
            const regex = /^(\d+)(,\d+)*$/;
            return regex.test(input);
        };
        if (this.state.selectedMys.length === 0) {
            return false;
        }
        if (!isCommaSeparatedInts(this.state.inputSubIds)) {
            return false;
        }
        return true;
    }
}

const HistoricalFilesPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(HistoricalFilesView);

// STYLES CONTAINER
const HistoricalFilesPage = withStyles(styles)(
    HistoricalFilesPageWithState
);

export default HistoricalFilesPage;